import {
  mode,
  StyleFunctionProps,
  transparentize,
} from "@chakra-ui/theme-tools";

const baseStyle = {
  table: {
    bg: "bg-surface",
    whiteSpace: "nowrap",
  },
  th: {
    fontWeight: "medium",
    textTransform: "normal",
    letterSpacing: "normal",
    borderTopWidth: "1px",
    whiteSpace: "nowrap",
  },
};

const variants = {
  simple: (props: StyleFunctionProps) => ({
    th: {
      color: "muted",
      bg: mode("gray.50", transparentize("gray.700", 0.4)(props.theme))(props),
    },
  }),
  striped: (props: StyleFunctionProps) => ({
    th: {
      color: "muted",
      borderBottomWidth: "0px",
    },
    thead: {
      "th,td": {
        borderWidth: "0px",
      },
    },
    tbody: {
      tr: {
        "th,td": {
          borderWidth: "0px",
        },
        "&:last-of-type": {
          "th, td": {
            borderBottomWidth: "1px",
          },
        },
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "0px",
          },
          td: {
            bg: mode(
              "gray.50",
              transparentize("gray.700", 0.4)(props.theme),
            )(props),
          },
        },
      },
    },
  }),
  "th-striped": () => ({
    th: {
      borderBottomWidth: "0px",
      "&:last-of-type": {
        borderLeftWidth: "1px",
        borderLeftColor: "th.cream3",
      },
    },
    thead: {
      "th,td": {
        borderWidth: "0px",
      },
    },
    tbody: {
      tr: {
        td: {
          "&:last-of-type": {
            borderLeftWidth: "1px",
            borderLeftColor: "th.cream3",
          },
        },
        "th,td": {
          borderWidth: "0px",
        },
        "&:last-of-type": {
          "th, td": {
            borderBottomWidth: "1px",
          },
        },
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "0px",
          },
          td: {
            bg: "th.cream1",
          },
        },
      },
    },
    tfoot: {
      td: {
        "&:last-of-type": {
          borderLeftWidth: "1px",
          borderLeftColor: "th.cream3",
        },
      },
    },
  }),
  "th-striped-col": () => ({
    td: {
      bg: "th.cream1",
      px: 4,
      py: 4,
    },
    th: {
      bg: "th.cream1",
      borderBottomWidth: "0px",
      px: 2,
    },
    thead: {
      "th,td": {
        borderWidth: "0px",
        "&:last-of-type": {
          bg: "th.white",
        },
      },
    },
    tbody: {
      tr: {
        borderTopWidth: "1px",
        borderTopColor: "th.cream3",
        "th,td": {
          borderWidth: "0px",
        },
        "th, td": {
          "&:last-of-type": {
            bg: "th.white",
          },
        },
      },
    },
    tfoot: {
      tr: {
        borderTopWidth: "1px",
        borderTopColor: "th.cream3",
      },
      "th,td": {
        "&:last-of-type": {
          bg: "th.white",
        },
      },
    },
  }),
};

const sizes = {
  md: {
    th: {
      lineHeight: "1.25rem",
    },
    td: {
      fontSize: "sm",
    },
  },
};

export const Table = {
  baseStyle,
  sizes,
  variants,
};
